export enum TransactionType {
  ADD = 'ADD',
  DEDUCT = 'DEDUCT',
}

export enum ActionType {
  WELCOME_BONUS = 'WELCOME_BONUS',
  REPORT_AQUISITION = 'REPORT_AQUISITION',
  PLAN_PURCHASE = 'PLAN_PURCHASE',
  NOT_DEFINED = 'NOT_DEFINED',
  REPORT_UPGRADE = 'REPORT_UPGRADE',
  REPORT_SYNC = 'REPORT_SYNC',
}

export interface Transaction {
  id: string;
  date: Date;
  amount: number;
  balanceAfter: number;
  type: TransactionType;
  action: string;
  link?: string | undefined;
}
